import { client as request } from "../../api/request";

export interface otherCompanyConstruction {
  id: string;
  serviceTaskTypeId: number;
  name: string;
  shortName: string;
  mConstructionId: number;
}

/**
 * 工事内容を取得する
 */
export async function getOtherCompanyConstruction(id: string = "") {
  const otherCompanyConstruction = await request.get(
    "get_m_other_company_construction.php",
    {
      id
    }
  );
  return otherCompanyConstruction;
}

/**
 * 工事内容を取得する
 */
export async function getOtherCompanyConstructionEdit(id: string = "") {
  const otherCompanyConstruction = await request.get(
    "get_m_other_company_construction.php",
    {
      id
    }
  );
  return otherCompanyConstruction[0];
}

/**
 * 工事内容を保存する
 */
export async function saveOtherCompanyConstruction(data: FormData) {
  const res = await request.post("save_m_other_company_construction.php", data);
  return res.otherCompanyConstructionId;
}

/**
 * 工事内容を削除する
 */
export async function deleteOtherCompanyConstruction(id: any) {
  await request.post("delete_m_other_company_construction.php", { id });
}
